import React from 'react';
import * as _ from 'lodash';

import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

import { CompanyBranchService } from '../../../services/CompanyBranches';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * 支店選択ドロップダウン
 * @props {number}jv_company_branch_id:
 * @props {number}my_branch={my_branch}
 * @props {string}name:validateの時に利用される項目名のプロパティ名(?)
 * @props {number}value:項目のid,選択項目(this.state.selected)と同じ場合ラジオボタンが選択状態になる
 * @props {function}set:項目を選択した時点に実行するcallback(formValuesにデータを入れる、など)
 * @props {string}setkey:this.props.setのcallbackの時点に入れるプロパティ名(例：state.formValues.[company_branch_id])
 * @props {function}validate:マウスを外にクリックした時点に実行する(バリデーション用)
 * @props {boolean}isChildElement:<FormElement>あるいは<div>'form-list__element'の中に存在する場合はtrueにする
 * @props {string}placeholder=プルダウンのデフォルトテキストを変更する場合利用する(「支店を選択」)
 */
export class CompanyBranchDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false, // ロード完了フラグ
      opened: false, // 開閉フラグ
      options: [], // 支店取得データ一覧
      condition: {
        // 検索条件
        name: '',
      },
      loadSize: 0,
      isLoading: true, // ロード中フラグ
      selected: null, // 選択したデータのID
      selectedName: '', // 選択したデータの(name)
      temporarySelected: null, // 選択したデータのtemp(id)
      temporarySelectedName: '', // 選択したデータのtemp(name)
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-branch-id-${this.id}`; // スクロールロード用ID
    this.search = this.search.bind(this); // 検索
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリック
    this.getBranches = this.getBranches.bind(this); // 支店情報一覧取得
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
  }

  componentDidMount() {
    this.getBranches(() => {});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clearFlag) {
      const condition = { ...this.state.condition };
      condition.name = '';
      this.setState({ condition });
      this.search();
    }
    // 初期値が設定されていた場合はselectedへセット
    if (nextProps.value !== this.state.selected) {
      this.setState({
        selected: nextProps.value,
        selectedName: nextProps.my_branch_name,
        temporarySelected: nextProps.value,
        temporarySelectedName: nextProps.my_branch_name,
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
    // フォーカスアウト時のバリデーション
    if (
      this.props.setkey === 'company_branch_id' &&
      _.isFunction(this.props.validate)
    ) {
      this.props.validate(this.props.name);
    }
  };

  /**
   * 開閉イベント
   */
  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  setValue = () => {
    let { selected, selectedName } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    selectedName = this.state.temporarySelectedName;

    this.setState(
      {
        selected,
        selectedName,
        opened: false,
      },
      () => {
        this.props.set(this.props.setkey, selected);
      }
    );
  };

  /**
   * 検索
   */
  search = e => {
    let name = '';
    if (this.search_timout_id) {
      clearTimeout(this.search_timout_id);
    }

    if (_.isUndefined(e) || _.isNull(e)) {
      name = '';
    } else {
      name = e.target.value;
    }

    this.search_timout_id = setTimeout(() => {
      if (_.isString(name)) {
        let condition = { ...this.state.condition };
        condition.name = name;
        this.setState(
          {
            loaded: false,
            loadSize: 0,
            condition,
            isLoading: true,
            options: [],
          },
          () => {
            this.getBranches(() => {}, this.state, true);
          }
        );
      }
    }, 500);
  };

  /**
   * 選択肢をクリック
   * @param id {int}
   * @param checked {bool} 選択・未選択判定
   */
  handleSelectedRow = (id, checked) => {
    let { temporarySelected, temporarySelectedName } = { ...this.state };
    if (checked === true) {
      temporarySelected = id;
      const selectedRow = _.find(this.state.options, option => {
        return option.id === id;
      });
      // 選択した職種の名前をtempへ
      temporarySelectedName = selectedRow.name;
    } else {
      temporarySelected = null;
      temporarySelectedName = '';
    }

    this.setState(
      {
        temporarySelected,
        temporarySelectedName,
      },
      () => {
        this.setValue();
      }
    );
  };

  clearSelectedRow = () => {
    this.setState(
      {
        selected: null,
        selectedName: '',
        temporarySelected: null,
        temporarySelectedName: '',
      },
      () => {
        this.setValue();
      }
    );
  };

  /**
   * 支店情報一覧取得
   * @param notify {function}
   * @param searchInfo {object}
   * @param new_flg {bool} 取得結果を置き換えるかどうか
   */
  getBranches(notify, searchInfo = {}, new_flg = false) {
    let loadSize = _.isEmpty(searchInfo)
      ? Number(this.state.loadSize)
      : searchInfo.loadSize;
    let loaded = _.isEmpty(searchInfo) ? this.state.loaded : searchInfo.loaded;
    if (loaded) {
      notify('end');
      this.setState({ isLoading: false });
      return;
    }

    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: loadSize,
      name: this.state.condition.name,
      my_branch: this.props.my_branch,
      jv_company_branch_id: this.props.jv_company_branch_id || null,
    };

    CompanyBranchService.companyBranchList(params).then(response => {
      if (response.result) {
        const branches = response.data.entities.company_branches;
        if (_.isEmpty(branches)) {
          this.setState({ loaded: true });
        } else {
          let options;
          if (new_flg) {
            options = branches;
          } else {
            options = [...this.state.options];
            _.each(branches, branch => {
              options.push(branch);
            });
          }
          this.setState({ options, loaded: false });
        }
        loadSize += branches.length;
        this.setState({ loadSize, isLoading: false });
        notify();
      }
    });
  }

  render() {
    const getDropdownLabel = () => {
      let name = this.props.placeholder || '支店名を選択';
      if (!_.isUndefined(this.props.my_branch_name)) {
        name = this.props.my_branch_name;
      }
      const option = _.find(this.state.options, {
        id: this.state.selected,
      });
      if (!_.isUndefined(option)) {
        name = option.name;
      } else {
        name = this.state.selectedName || name;
      }
      return name;
    };
    const isChildElement = this.props.isChildElement || false;

    const dropdownContents = (
      <div
        id='form-dropdown'
        className='dropdown-multi-select --col-xs-12 --col-md-12 --col-lg-4 --col-xl-5'
        ref={this.parent}
      >
        <div className='dropdown-multi-select__header'>
          <div
            id='form-dropdown-btn'
            href=''
            className='dropdown-select'
            onClick={() => this.handleOpen()}
          >
            <span className='dropdown-select__txt'>{getDropdownLabel()}</span>
          </div>
        </div>
        <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        {this.state.opened && (
          <div
            id='form-dropdown-list'
            className='dropdown dropdown--dropdown-list show'
          >
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  defaultValue={this.state.condition.name}
                  onChange={this.search}
                />
              </div>
              {this.props.isOptional && (
                <div className='dropdown-single-select__item'>
                  <FormDropdownClearButton onClick={this.clearSelectedRow} />
                </div>
              )}
              <div className='dropdown-multi-select__item'>
                <div
                  className='dropdown-multi-select__scroll'
                  id={this.targetId}
                >
                  <ul className='single-select'>
                    {_.map(this.state.options, (option, index) => (
                      <FormDropdownRadio
                        key={index}
                        option={option}
                        checked={this.state.temporarySelected == option.id}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        forId='company-branch'
                      />
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      callback={this.getBranches}
                      reset={this.state.isLoading}
                      isLoading={this.state.isLoading}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='form-list__alert show'>{this.props.error}</div>
      </div>
    );
    return isChildElement ? (
      <React.Fragment>{dropdownContents}</React.Fragment>
    ) : (
      <div className='form-list__element'>{dropdownContents}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/CompanyBranch.jsx